export function confirmResetManualOverrides(count, language = "de", { withRecalculate = true } = {}) {
  const n = Number(count || 0);
  if (n <= 0) return false;

  const isEn = language === "en";
  if (withRecalculate) {
    return window.confirm(
      isEn
        ? `Remove all ${n} manual classification(s) and recalculate from auto-classification only?\n\nThis cannot be undone.`
        : `Alle ${n} manuelle Klassifizierung(en) entfernen und nur mit Auto-Klassifizierung neu berechnen?\n\nDas kann nicht rückgängig gemacht werden.`
    );
  }

  return window.confirm(
    isEn
      ? `Remove all ${n} manual edit${n === 1 ? "" : "s"} from this set?\n\nYou can start a new calculation manually afterwards. This cannot be undone.`
      : `Alle ${n} manuelle Edit${n === 1 ? "" : "s"} aus diesem Set entfernen?\n\nDu kannst danach manuell „Set berechnen“ starten. Das kann nicht rückgängig gemacht werden.`
  );
}

export function manualOverrideActiveLabel(count, language = "de") {
  const n = Number(count || 0);
  if (n <= 0) return "";

  return language === "en"
    ? `${n} manual classification${n === 1 ? "" : "s"} active`
    : `${n} manuelle Klassifizierung${n === 1 ? "" : "en"} aktiv`;
}

/** Kompakte Anzeige für Status-Kachel im Dashboard. */
export function manualOverrideStatusChipLabel(count, language = "de") {
  const n = Number(count || 0);
  if (n <= 0) return "";

  return language === "en"
    ? `${n} manual edit${n === 1 ? "" : "s"}`
    : `${n} manuelle Edit${n === 1 ? "" : "s"}`;
}

export function manualOverridePreservedToast(count, language = "de") {
  const n = Number(count || 0);
  if (n <= 0) return "";

  return language === "en"
    ? `${n} manual classification${n === 1 ? " was" : "s were"} preserved during recalculation.`
    : `${n} manuelle Klassifizierung${n === 1 ? " wurde" : "en wurden"} bei der Neuberechnung beibehalten.`;
}

export function manualOverrideResetSuccessToast(language = "de") {
  return language === "en"
    ? "Manual classifications reset. Recalculation completed with auto-classification only."
    : "Manuelle Klassifizierungen zurückgesetzt. Neuberechnung nur mit Auto-Klassifizierung abgeschlossen.";
}

export function manualOverrideResetOnlySuccessToast(language = "de") {
  return language === "en"
    ? "Manual edits removed. Use “Calculate Set” or “Recalculate Set” when you want a new run."
    : "Manuelle Edits entfernt. Starte „Set berechnen“ oder „Set neu berechnen“, wenn du neu rechnen möchtest.";
}

const LIQUIDITY_TAX_CLASSES = new Set([
  "liquidity_add_out",
  "liquidity_remove_lp_out",
  "liquidity_add_lp_in",
  "liquidity_remove_in",
]);

const VTHO_SECTION_ONLY_INCOME = new Set(["generated", "vtho_synthetic"]);

function normalizeOverrideClassKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_");
}

/** @returns {{ ok: true } | { ok: false, code: string, message: string, messageEn: string }} */
export function validateManualOverrideClassificationForUi(cls) {
  const key = normalizeOverrideClassKey(cls);
  if (!key || key === "auto") return { ok: true };

  if (LIQUIDITY_TAX_CLASSES.has(key)) {
    return {
      ok: false,
      code: "LIQUIDITY_NOT_OVERRIDABLE",
      message:
        "Liquidity-Klassen werden automatisch erkannt und nur in der Liquidity-TaxTable verarbeitet — manuelle Overrides sind nicht erlaubt.",
      messageEn:
        "Liquidity classes are detected automatically and processed only in the Liquidity tax table — manual overrides are not allowed.",
    };
  }

  if (VTHO_SECTION_ONLY_INCOME.has(key)) {
    return {
      ok: false,
      code: "SYNTHETIC_NOT_OVERRIDABLE",
      message:
        "Synthetische Klassen (z. B. generated) werden vom System erzeugt und können nicht manuell gesetzt werden.",
      messageEn:
        "Synthetic classes (e.g. generated) are produced by the system and cannot be set manually.",
    };
  }

  return { ok: true };
}
